module.exports = __webpack_public_path__ + "static/ruscitto-shirt-40574ea3b7398bc2518e275e34bf1d6b.jpg";